import { contactActions } from "./contact-slice";

export const resetForm = async (dispatch) => {
  dispatch(contactActions.startReset());
  setTimeout(() => {
    dispatch(contactActions.finishReset());
  }, 100);
};
